import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'office-ui-fabric-react/lib/Dropdown';
import { campaignUserRoleOptions } from '../../helpers/constants';
import { CaretDown } from '../icons';

const UserRolePicker = ({
  selectedKey,
  onChange,
  errorMessage,
  required,
  className,
}) => (
  <Dropdown
    onRenderCaretDown={() => <CaretDown />}
    className={className}
    errorMessage={errorMessage}
    label="User Role"
    required={required}
    placeholder="Select"
    selectedKey={selectedKey}
    onChange={onChange}
    options={[
      {
        key: 0,
        text: 'Select',
      },
      ...campaignUserRoleOptions,
    ]}
  />
);

UserRolePicker.propTypes = {
  selectedKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
};

UserRolePicker.defaultProps = {
  errorMessage: '',
  required: false,
  className: '',
};

export default UserRolePicker;
